import { render, staticRenderFns } from "./main-component.vue?vue&type=template&id=3831b2f0"
import script from "./main-component.vue?vue&type=script&lang=js"
export * from "./main-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports